import React, { useState } from 'react'
import styles from './PasswordInput.module.css'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
import { useEffect } from 'react'

function PasswordInput(props) {
    const [showPassword, setShowPassword] = useState(false)
    const onEnter = props.onEnter || null
    const [warn, setWarn] = useState(props.disabled || false)

    let disabled = props.disabled || false
    let value = props.value || ''
    let regex = props.regex || null

    useEffect(() => {
        setWarn(props.validate)
    }, [props.validate])
    

    const handleCopy = (e) => {
        e.preventDefault(); 
      };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (onEnter) {
                onEnter()
            }
        }
    }


    return (
        <div>
            {(props.label || props.placeholder) && !props.disabledLabel && (
                <label
                htmlFor={props.id}
                className={styles.label}
                >
                {props.label || props.placeholder}
                </label>
            )}
            <div
                className={`${styles.input} ${warn ? styles.warn : ''} ${disabled ? styles.disabled : ''}`}
            >
                <input
                    id={props.id}
                    value={value}
                    disabled={disabled}
                    placeholder={props.placeholder}
                    type={showPassword ? 'text' : 'password'}
                    autoComplete='off'
                    onCopy={handleCopy}
                    // onChange={(e) => props.setValue(e.target.value)}
                    onChange={(e) => {
                        if (regex) {
                            if (regex.condition.test(e.target.value)) {
                                props.setValue(e.target.value)
                                if (regex.regex.test(e.target.value)) {
                                    setWarn(false)
                                } else {
                                    setWarn(true)
                                }
                            }
                        } else {
                            props.setValue(e.target.value)
                        }
                    }}
                    onKeyDown={handleKeyDown}
                ></input>
                {
                    showPassword ?
                        <EyeIcon className={styles.icon} onClick={() => setShowPassword(false)} /> :
                        <EyeSlashIcon className={styles.icon} onClick={() => setShowPassword(true)} />
                }
            </div>
        </div>

    )
}

export default PasswordInput